import React, { FC, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import DebouncedTextField from "../../components/DebouncedTextField";
import useAssessmentLabel from "../../hooks/useAssessmentLabel";

// @ts-expect-error - css
import styles from "./Assessment.module.css";

interface InvestigationInterface {
  investigation: string;
  onChange: (value: string) => void;
}

const MAX_LENGTH = 2000;

const Investigation: FC<InvestigationInterface> = ({ investigation, onChange }) => {
  const assessmentLabels = useAssessmentLabel();
  const [localValue, setLocalValue] = React.useState(investigation || "");

  useEffect(() => {
    setLocalValue(investigation || "");
  }, [investigation]);

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel}>
        <Typography component="span" fontWeight="600">
          {assessmentLabels.investigation}
        </Typography>
      </Box>
      <Box className={styles.assessmentField}>
        <DebouncedTextField
          margin="dense"
          id="outlined-basic"
          data-testmation="investigationTextField"
          fullWidth
          multiline
          variant="outlined"
          rows="3"
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: { maxLength: MAX_LENGTH },
            formHelperText: { style: { position: "absolute", right: 0, bottom: 0, margin: 5 } }
          }}
          placeholder="Type investigation here"
          value={localValue}
          onChange={(e) => {
            setLocalValue(e.target.value);
            onChange(e.target.value);
          }}
          debounceAt={400}
          helperText={`${localValue.length}/${MAX_LENGTH}`}
        />
      </Box>
    </Box>
  );
};

export default Investigation;
